import React from "react";
import {
  NavLink,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams
} from "react-router-dom";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarHeader,
  SidebarContent,
  SidebarFooter
} from "react-pro-sidebar";
import AvatarC from "../avatar/index";
import "./index.scss";
import { SideBarProps } from "./sidebar.interface";
import { scrollToTop } from "../../../utils/const";
import { useLogout } from "../../../hooks/react-query/auth/useLogout";
import { Tooltip } from "primereact/tooltip";
import LogoutDialog from "../logout-dialog";
import { LogoutClicked, ToggleMenu } from "../../investor/amplitude";
import { useQueryClient } from "@tanstack/react-query";
import useContextHook from "../../../hooks/context/useContext";

const SideBarC = ({
  // collapsed,
  // toggled,
  // handleToggleSidebar,
  handleMenuItemClick,
  // handleCollapsedChange,
  activeIndex,
  type
}: SideBarProps) => {
  const [searchParams] = useSearchParams();
  const { mobileNumber, setMobileNumber } = useContextHook();
  const { propertyId } = useParams();
  const [visibleLogout, setVisibleLogout] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const logoutMutation: any = useLogout(
    (data) => {
      setLoading(false);
      setVisibleLogout(false);
      localStorage.clear();
      // navigate(
      //   `?continue=${location.pathname}${
      //     location.search?.length > 0 ? location.search : ""
      //   }`
      // );
    },
    (error) => {
      setLoading(false);
      setVisibleLogout(false);
      localStorage.clear();
      // navigate(`?continue=${location.pathname}`);
      console.log("error", error);
    }
  );
  const handleLogout = async () => {
    if (type !== "investor") {
      setLoading(true);
      (await logoutMutation).mutate();
    } else {
      setMobileNumber("");
      const currentPath = location.pathname;
      const searchParams = new URLSearchParams(location.search);
      const continueUrl = searchParams.toString()
        ? `${currentPath}?${searchParams.toString()}`
        : currentPath;
      navigate(`/investor-login?continue=${encodeURIComponent(continueUrl)}`);
      localStorage.removeItem("investor-access-token");
      localStorage.removeItem("sfid");
      localStorage.removeItem("userId");
    }
  };
  const userObj = localStorage.getItem("user-detail");
  const userDetail = userObj && JSON.parse(userObj ?? "");
  const queryClient = useQueryClient();
  const cid = searchParams.get("cid") || "";
  const eq = searchParams.get("eq") || "";
  // const {
  //   access_token,
  //   banner_photo_url,
  //   first_name,
  //   last_name,
  //   medium_banner_photo_url,
  //   medium_photo_url,
  //   name,
  //   picture,
  //   small_banner_photo_url,
  //   thumbnail,
  //   username,
  // } = userDetail || {};
  return (
    <ProSidebar
      collapsed={true}
      toggled={true}
      // onToggle={handleToggleSidebar}
      breakPoint="md"
    >
      <SidebarHeader>
        <Menu iconShape="circle">
          <MenuItem
            onClick={() => {
              if (type === "agent") {
                navigate("/properties");
                scrollToTop();
                handleMenuItemClick(1);
              } else {
                ToggleMenu("Properties");
                navigate("/investor/properties-listing");
                handleMenuItemClick(1);
              }
            }}
          >
            <img src={"/images/logo.svg"} alt="logo" className="logo" />
          </MenuItem>
          {/* {!collapsed && (
            <MenuItem onClick={handleCollapsedChange}>
              <Toggle />
              <img src='/images/layout-left.svg' alt='' />
            </MenuItem>
          )}  */}
        </Menu>
      </SidebarHeader>
      <SidebarContent>
        {type === "agent" ? (
          <Menu iconShape="circle">
            <Tooltip
              content={`Dashboard`}
              target=".dashboard"
              className={"TooltipSidebar"}
            />
            <MenuItem
              active={activeIndex === 0}
              onClick={() => {
                scrollToTop();
                navigate("/dashboard");
                handleMenuItemClick(0);
              }}
              icon={
                activeIndex === 0 ? (
                  <img src="/images/home-white.svg" alt="" />
                ) : (
                  <img src="/images/home.svg" alt="" />
                )
              }
              className={`${`dashboard`} ${
                activeIndex === 0 ? "menu-collapsed" : ""
              } ${activeIndex !== 0 ? "menu-collapsed-all" : ""}`}
            >
              {/* <NavLink to="/dashboard?page=1&limit=10">Dashboard</NavLink> */}
            </MenuItem>
            <Tooltip
              content={`Properties`}
              target=".properties"
              className={"TooltipSidebar"}
            />
            <MenuItem
              active={activeIndex === 1}
              onClick={() => {
                const mapPersist = localStorage.getItem("map-persist");
                const filter = localStorage.getItem("filter");
                const mapPersistParse = mapPersist && JSON.parse(mapPersist);
                const filterParse =
                  filter !== null
                    ? JSON.parse(filter)
                    : {
                        state: { name: "CA" },
                        status: { name: "Active" }
                      };
                const params = new URLSearchParams();
                console.log(params, "params");
                if (mapPersistParse && typeof mapPersistParse === "object") {
                  Object.keys(mapPersistParse).forEach((key) => {
                    if (
                      mapPersistParse[key] !== undefined &&
                      mapPersistParse[key] !== null
                    ) {
                      params.set(key, mapPersistParse[key]);
                    }
                  });
                }

                if (filterParse && typeof filterParse === "object") {
                  Object.keys(filterParse).forEach((key) => {
                    if (
                      filterParse[key] &&
                      filterParse[key].name !== undefined &&
                      filterParse[key].name !== null
                    ) {
                      params.set(key, filterParse[key].name);
                    }
                  });
                }
                navigate(`/properties?${params.toString()}`);
                handleMenuItemClick(1);
              }}
              icon={
                activeIndex === 1 ? (
                  <img src="/images/property-white-icon.svg" alt="" />
                ) : (
                  <img src="/images/property-icon.svg" alt="" />
                )
              }
              className={`${`properties`} ${
                activeIndex === 1 ? "menu-collapsed" : ""
              } ${activeIndex !== 1 ? "menu-collapsed-all" : ""}`}
            >
              <NavLink to={`/properties`}>Properties</NavLink>
            </MenuItem>
            <Tooltip
              content={`Investor Dashboard`}
              target=".InvestorDashboard"
              className={"TooltipSidebar"}
            />
            <MenuItem
              active={activeIndex === 2}
              onClick={() => {
                navigate("/inv-list");
                handleMenuItemClick(2);
              }}
              icon={
                activeIndex === 2 ? (
                  <img src="/images/investor-active-web.svg" alt="" />
                ) : (
                  <img src="/images/investor-active.svg" alt="" />
                )
              }
              className={`${`InvestorDashboard`} ${
                activeIndex === 2 ? "menu-collapsed" : ""
              } ${activeIndex !== 2 ? "menu-collapsed-all" : ""}`}
            >
              <NavLink to={`/inv-list`}>Investor Dashboard</NavLink>
            </MenuItem>
            <Tooltip
              content={`Calling Pipeline`}
              target=".CallingPipeline"
              className={"TooltipSidebar"}
            />
            <MenuItem
              active={activeIndex === 3}
              onClick={() => {
                navigate("/calling-pipeline");
                handleMenuItemClick(3);
              }}
              icon={
                activeIndex === 3 ? (
                  <img src="/images/calling-icon-black.svg" alt="" />
                ) : (
                  <img src="/images/calling-icon.svg" alt="" />
                )
              }
              className={`${`CallingPipeline`} ${
                activeIndex === 3 ? "menu-collapsed" : ""
              } ${activeIndex !== 3 ? "menu-collapsed-all" : ""}`}
            >
              <NavLink to={`/calling-pipeline`}>Calling Pipeline</NavLink>
            </MenuItem>
          </Menu>
        ) : (
          <Menu iconShape="circle">
            <Tooltip
              content={`Dashboard`}
              target=".investor-dashboard"
              className={"TooltipSidebar"}
            />
            <MenuItem
              active={activeIndex === 0}
              onClick={() => {
                scrollToTop();
                ToggleMenu("Dashboard");
                navigate("/investor/dashboard?panel=0&page=1&limit=10");
                handleMenuItemClick(0);
              }}
              icon={
                activeIndex === 0 ? (
                  <img src="/images/home-white.svg" alt="" />
                ) : (
                  <img src="/images/home.svg" alt="" />
                )
              }
              className={`${`investor-dashboard`} ${
                activeIndex === 0 ? "menu-collapsed" : ""
              } ${activeIndex !== 0 ? "menu-collapsed-all" : ""}`}
            ></MenuItem>
            <Tooltip
              content={`Properties`}
              target=".properties"
              className={"TooltipSidebar"}
            />
            <MenuItem
              active={activeIndex === 1}
              onClick={() => {
                ToggleMenu("Properties");
                navigate(`/investor/properties-listing`);
                handleMenuItemClick(1);
              }}
              icon={
                activeIndex === 1 ? (
                  <img src="/images/property-white-icon.svg" alt="" />
                ) : (
                  <img src="/images/property-icon.svg" alt="" />
                )
              }
              className={`${`properties`} ${
                activeIndex === 1 ? "menu-collapsed" : ""
              } ${activeIndex !== 1 ? "menu-collapsed-all" : ""}`}
            >
              <NavLink to={`/investor/properties-listing`}>Properties</NavLink>
            </MenuItem>
          </Menu>
        )}
      </SidebarContent>
      <SidebarFooter>
        <div className="sidebar-btn-wrapper">
          <div className="footer-link">
            <Menu
              iconShape="circle"
              onClick={() => {
                setVisibleLogout(true);
              }}
            >
              <Tooltip
                target=".logout"
                content={`Log Out`}
                className={"TooltipSidebar"}
              />
              <MenuItem
                className="logout"
                icon={<img src="/images/logout.svg" alt="" />}
              >
                {/* <NavLink
                  to={``}
                >
                  Log Out
                </NavLink> */}
              </MenuItem>
            </Menu>
          </div>
          <div className="footer-link">
            <Menu iconShape="circle">
              <Tooltip
                content={`Profile`}
                target=".profile"
                className={"TooltipSidebar"}
              />
              {type === "agent" && (
                <MenuItem
                  active={activeIndex === 4}
                  onClick={() => {
                    if (type === "agent") {
                      handleMenuItemClick(4);
                    }
                  }}
                  className="profile"
                  icon={
                    <>
                      <AvatarC
                        image={userDetail?.banner_photo_url || ""}
                        label={
                          userDetail?.name?.split(" ")[0]?.slice(0, 1) +
                          userDetail?.name?.split(" ")[1]?.slice(0, 1)
                        }
                        size="large"
                        shape="circle"
                      />
                    </>
                  }
                >
                  {type === "agent" ? (
                    <NavLink to="/profile">Profile</NavLink>
                  ) : (
                    <NavLink to="#">Profile</NavLink>
                  )}
                </MenuItem>
              )}
              <LogoutDialog
                cancelVisible={visibleLogout}
                setCancelVisible={setVisibleLogout}
                buttonLabel="Logout"
                message="Are you sure you want to logout?"
                header="Logout"
                loading={loading}
                onClick={() => {
                  if (type === "investor") {
                    const investorPropertyDetail: any =
                      queryClient.getQueryData([
                        "investor-Property-Detail",
                        propertyId
                      ]);
                    if (investorPropertyDetail?.data) {
                      LogoutClicked({
                        shareId: propertyId || "",
                        propertyId: investorPropertyDetail?.data?.id || "",
                        opportunitySFID:
                          investorPropertyDetail?.data?.opportunitySFID || "",
                        pubPropertySFID:
                          investorPropertyDetail?.data?.pubPropertySFID || "",
                        propertySFID:
                          investorPropertyDetail?.data?.propertySFID || "",
                        linkCId: cid,
                        linkEmailId: eq,
                        ...(mobileNumber && { mobileNumber: mobileNumber })
                      });
                    }
                  }
                  handleLogout();
                }}
              />
            </Menu>
          </div>
        </div>
      </SidebarFooter>
    </ProSidebar>
  );
};

export default React.memo(SideBarC);
